import { env } from '@noor/config';
import { MOCK_ADMIN_TOKEN, clearAuthToken, readAuthToken } from '@noor/api';

/**
 * Drops a stored mock token when the app runs live. `mock-admin-token` is
 * issued only by the MSW login handler, so it can never authorize against a
 * real backend — replaying it just produces a doomed `401` (and a confusing
 * curl, when the token is copied out of storage). Clearing it up front sends
 * the user straight to `/login` via the route guards instead.
 */
export function dropStaleMockToken(options?: { mockEnabled?: boolean }): boolean {
  const mockEnabled = options?.mockEnabled ?? env.VITE_ENABLE_MSW;
  if (mockEnabled) return false;
  if (readAuthToken() !== MOCK_ADMIN_TOKEN) return false;
  clearAuthToken();
  return true;
}
